// Typelizer digest d67709a16aea92445be4ba5919510dd6
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** PATCH /c/:company_id/payments/bulk_detach */
  bulkDetach: (options?: RouteOptions): RouteDefinition<'patch'> => ({
    url: buildUrl('/c/:company_id/payments/bulk_detach', {}, options),
    method: 'patch',
  }),

  /** PATCH /c/:company_id/payments/bulk_update_category */
  bulkUpdateCategory: (options?: RouteOptions): RouteDefinition<'patch'> => ({
    url: buildUrl('/c/:company_id/payments/bulk_update_category', {}, options),
    method: 'patch',
  }),

  /** PATCH /c/:company_id/payments/bulk_update_direction */
  bulkUpdateDirection: (options?: RouteOptions): RouteDefinition<'patch'> => ({
    url: buildUrl('/c/:company_id/payments/bulk_update_direction', {}, options),
    method: 'patch',
  }),

  /** GET /c/:company_id/payments */
  index: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/payments', {}, options),
    method: 'get',
  }),

  /** GET /c/:company_id/payments/:id */
  show: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/payments/:id', params, options),
    method: 'get',
  }),

  /** PATCH /c/:company_id/payments/:id */
  update: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/c/:company_id/payments/:id', params, options),
    method: 'patch',
  }),
}
